// Keep this line in and don't add the dependencies
// as adding them causes re-renders when using
// this component in the wild (when state is
// being supplied to it.
/* eslint-disable react-hooks/exhaustive-deps */
import { add, differenceInDays, isBefore, isSameDay } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { getLastPossibleMonth, getMinDateAfterMidDayToday } from '../helpers';
import DialogContent from './DialogContent';
const RangeDatePicker = ({ startDate, endDate, onChange, startWeekDay, minDate = new Date(), maxDate, weekDayFormat, monthFormat, highlightToday = true, seasons, duration, singleColumn = false, singleCalendar = false, isAnyDaySelectable, disableUnusableDates = false, availableDates, leadingPrices, focusDate, setFocusDate, enableDepositInfo, showRelativePricing = false, }) => {
    const [inputFocus, setInputFocus] = useState('from');
    const [fromDate, setFromDate] = useState(startDate);
    const [storedPrice, setStoredPrice] = useState(null);
    const [toDate, setToDate] = useState(endDate);
    const [minDateAfterMidDay, setMinDateAfterMidDay] = useState(minDate);
    const [hoverDate, setHoverDate] = useState(undefined);
    const [isFirstTime, setIsFirstTime] = useState(false);
    function notifyChange() {
        onChange({
            fromDate,
            endDate: toDate,
            price: storedPrice,
        });
    }
    useEffect(() => {
        setIsFirstTime(true);
        // Ensures the current date can't be selected if after mid day
        const minDateIsToday = isSameDay(minDate, new Date());
        const minDateAfterMidDay = minDateIsToday ? getMinDateAfterMidDayToday(minDate) : minDate;
        setMinDateAfterMidDay(minDateAfterMidDay);
    }, []);
    useEffect(() => {
        if (startDate && endDate && differenceInDays(endDate, startDate) === duration)
            return;
        if (isFirstTime) {
            setFromDate(undefined);
            setToDate(undefined);
        }
    }, [duration]);
    useEffect(() => {
        const noDateSelected = !fromDate && !toDate;
        if (noDateSelected)
            return;
        notifyChange();
    }, [fromDate, toDate]);
    function onSelectDate(date, price) {
        if (price) {
            setStoredPrice(price);
        }
        else {
            setStoredPrice(null);
        }
        if (duration) {
            setFromDate(date);
            setToDate(add(date, { days: duration }));
            return;
        }
        if (inputFocus) {
            if (inputFocus === 'from' || (fromDate && isBefore(date, fromDate))) {
                setFromDate(date);
                setToDate(undefined);
                setInputFocus('to');
            }
            else {
                setToDate(date);
                setInputFocus('from');
            }
        }
    }
    function onHoverDate(date) {
        setHoverDate(date);
    }
    const endSeasons = getLastPossibleMonth(seasons);
    return (<DialogContent fromDate={fromDate} toDate={toDate} hoverDate={hoverDate} onSelectDate={onSelectDate} onHoverDate={onHoverDate} startWeekDay={startWeekDay} minDate={minDateAfterMidDay} maxDate={maxDate || endSeasons} weekDayFormat={weekDayFormat} monthFormat={monthFormat} highlightToday={highlightToday} singleCalendar={singleCalendar} singleColumn={singleColumn} showRelativePricing={showRelativePricing} seasons={seasons} duration={duration} isAnyDaySelectable={isAnyDaySelectable} disableUnusableDates={disableUnusableDates} availableDates={availableDates} leadingPrices={leadingPrices} focusDate={focusDate} setFocusDate={setFocusDate} enableDepositInfo={enableDepositInfo}/>);
};
export default RangeDatePicker;
